import { render } from "./C2cBuy.vue?vue&type=template&id=5fee3e22&scoped=true"
import script from "./C2cBuy.vue?vue&type=script&lang=js"
export * from "./C2cBuy.vue?vue&type=script&lang=js"

import "./C2cBuy.vue?vue&type=style&index=0&id=5fee3e22&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fee3e22"]])

export default __exports__